// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"041b3fb0","977":"b7ddcb23"}[chunkId] + ".chunk.js";
};